import { render, staticRenderFns } from "./DraggableItems.vue?vue&type=template&id=510845e8&scoped=true&"
import script from "./DraggableItems.vue?vue&type=script&lang=js&"
export * from "./DraggableItems.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItems.vue?vue&type=style&index=0&id=510845e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510845e8",
  null
  
)

export default component.exports